/**
 * Español (es) — a partial of `content/en.ts`.
 *
 * Anything omitted renders in English, on purpose. Only the interface strings
 * are translated so far: the marketing copy in the base file is placeholder,
 * and translating placeholder copy is work that has to be thrown away twice.
 */
import type { Translation } from '@/i18n/dictionary'

export const es: Translation = {
  nav: {
    languageLabel: 'Idioma',
    skipToContent: 'Ir al contenido',
    cta: { label: 'Hablemos' },
  },
  contactBand: {
    heading: '¡Hablemos!',
    cta: { label: 'Hablemos' },
    photoAlt: 'Cactus de colores enmarcados por un ribbon degradado de Digitopia',
  },
  footer: {
    rights: 'Todos los derechos reservados.',
  },
  preview: {
    badge: 'Vista previa',
    notice: 'Esta es una vista previa no aprobada de digitopia.ai. El contenido es un borrador.',
  },
  ui: {
    previous: 'Anterior',
    next: 'Siguiente',
  },
}
